import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Col, Row, Modal } from '_zari/core'

import Yup from '_zari/validation/_yup'

import ComentarioFormGroup from './formGroups/comentario'

const ValidationSchema = Yup.object().shape({
  comentario: Yup.string()
    .min(3)
    .max(500)
    .notRequired()
})

const ActualizarComentarioModal = ({
  handleClose,
  show,
  modalData,
  actualizarComentarioHandler
}) => {
  const formInitialValues = React.useMemo(
    () => ({
      comentario: modalData.comentario || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarComentarioHandler(data)
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>ACTUALIZAR COMENTARIO</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        onSubmit={submitHandler}
        validationSchema={ValidationSchema}
      >
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <ComentarioFormGroup
                    iError={errors.comentario}
                    iTouched={touched.comentario}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ActualizarComentarioModal)
